<div>
  <h4 class="m-t-0" mat-dialog-title>Benutzer löschen
  </h4>
  <p>{{'sureYouWantToDeleteStart' | translate}} {{data.name}} {{'sureToDeactivateEnd' | translate}}?</p>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="basic" id="stop" (click)="closeDialog()">{{'stop' | translate}}</button>
    <button mat-raised-button cdkFocusInitial id="deactivate" class="custom-button m-l-10" (click)="deleteUser()">{{'deactivate' | translate}}</button>
  </div>
</div>
